export enum UserStatus {
  Active = 'active',
  Cancelled = 'cancelled',
  Chargeback = 'chargeback',
  BrokenEnrollment = 'broken_enroll',
  Manual = 'manual',
  ThinFile = 'thin_file',
  ReturnReverse = 'returnreverse'
}
